// extracted by mini-css-extract-plugin
export default {"root":"GameByGeo_root__uXARs","icon":"GameByGeo_icon__uut3L"};